import { IAddCourseOfferingsToCourseCategoryActionPayload } from '../interfaces/add-course-offerings-to-course-category.action.payload.interface';

export class AddCourseOfferingsToCourseGroupCommand {
    module: { id: number };
    course_offerings: { id: number }[];
    course_group: { id: number };

    constructor(tempTap: IAddCourseOfferingsToCourseCategoryActionPayload) {
        this.module = { id: Number(tempTap.module.id) };
        this.course_offerings = tempTap.courseOfferings.length ? tempTap.courseOfferings.map((courseOffering) => ({ id: Number(courseOffering.id) })) : null;
        this.course_group = { id: Number(tempTap.courseGroup.id) };
    }
}
